// Mock data for AlphaGen Global clone

export const services = [
  {
    id: 1,
    title: 'Managed Services',
    description: 'End-to-end IT management that ensures seamless operations, enhanced security & optimized performance.',
    image: 'https://images.unsplash.com/photo-1600880292203-757bb62b4baf?w=800&q=80',
    link: '/managed-services',
    stats: [
      { value: '+40%', label: 'Productivity Increase' },
      { value: '+25%', label: 'Cost Efficiency Improvement' }
    ]
  },
  {
    id: 2,
    title: 'Modernization',
    description: 'Transform legacy systems into modern, scalable, cloud-native architectures that boost agility.',
    image: 'https://images.unsplash.com/photo-1518770660439-4636190af475?w=800&q=80',
    link: '/cloud-modernization',
    stats: [
      { value: '+60%', label: 'Deployment Speed' },
      { value: '+35%', label: 'System Uptime' }
    ]
  },
  {
    id: 3,
    title: 'AI Consultation',
    description: 'Strategic AI consulting — from opportunity discovery and roadmap to Generative AI, ML, and responsible AI deployment.',
    image: 'https://images.unsplash.com/photo-1677442136019-21780ecad995?w=800&q=80',
    link: '/ai-consulting',
    stats: [
      { value: '+50%', label: 'Process Automation' },
      { value: '+30%', label: 'Decision Accuracy' }
    ]
  },
  {
    id: 4,
    title: 'Cloud Consultant',
    description: 'Strategic guidance across AWS, Azure, and Google Cloud for cost-effective scaling.',
    image: 'https://images.unsplash.com/photo-1667372393119-3d4c48d07fc9?w=800&q=80',
    link: '/cloud-consulting',
    stats: [
      { value: '+45%', label: 'Cloud Cost Savings' },
      { value: '+55%', label: 'Deployment Efficiency' }
    ]
  },
  {
    id: 5,
    title: 'Staff Augmentation',
    description: 'Access top-tier engineering talent to accelerate your projects and scale your teams on demand.',
    image: 'https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=800&q=80',
    link: '/staff-augmentation',
    stats: [
      { value: '+70%', label: 'Team Velocity' },
      { value: '+40%', label: 'Time to Market' }
    ]
  }
];

export const whyChooseUs = [
  { title: 'Human-Centric Approach', description: 'We put people at the center of everything we build, ensuring our solutions align with real needs and deliver meaningful impact.', icon: 'Brain' },
  { title: 'AI-Driven Innovation', description: 'By leveraging advanced AI, we build solutions that improve efficiency and keep your business ahead of the curve.', icon: 'Sparkles' },
  { title: 'Scalable & Reliable', description: 'Our solutions are designed to grow with your business, offering flexibility while maintaining consistent performance and reliability.', icon: 'TrendingUp' },
  { title: 'End-to-End Support', description: 'From planning and implementation to ongoing optimization, we support you at every stage of your journey.', icon: 'Headphones' }
];

export const processSteps = [
  { number: '01', title: 'Understand & Analyse', description: 'Identify key opportunities, define objectives, and establish a strategic roadmap aligned with business goals.', image: 'https://images.unsplash.com/photo-1552664730-d307ca884978?w=800&q=80' },
  { number: '02', title: 'Design the Solution', description: "Design scalable system blueprints, integrations, and automation workflows tailored to your team's infrastructure.", image: 'https://images.unsplash.com/photo-1600880292089-90a7e086ee0c?w=800&q=80' },
  { number: '03', title: 'Implement & Optimize', description: 'Implement, optimize, and scale intelligent systems that deliver immediate and long-term operational impact.', image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800&q=80' }
];

export const blogs = [
  { title: 'Here\u2019s why most companies using AI get zero ROI', date: 'May 05, 2026', category: 'Insights', image: 'https://images.unsplash.com/photo-1620712943543-bcc4688e7485?w=800&q=80', link: 'https://www.linkedin.com/' },
  { title: 'Stop building tech. Start solving problems', date: 'April 30, 2026', category: 'Insights', image: 'https://images.unsplash.com/photo-1519389950473-47ba0277781c?w=800&q=80', link: 'https://www.linkedin.com/' },
  { title: 'Is your business cloud ready?', date: 'April 1, 2026', category: 'Insights', image: 'https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=800&q=80', link: 'https://www.linkedin.com/' }
];

export const faqs = [
  { q: "Who can benefit from Pratham Innovations' services?", a: 'Our services are designed for startups, SMEs, and large enterprises looking to scale efficiently, optimize costs, and enhance their IT operations.' },
  { q: 'How does Pratham Innovations ensure data security?', a: 'We implement industry-standard security protocols, including encryption at rest and in transit, multi-factor authentication, and regular security audits.' },
  { q: 'Does Pratham Innovations provide 24/7 support?', a: 'Yes, we offer round-the-clock monitoring and support services to ensure your critical infrastructure remains operational at all times.' },
  { q: 'Can Pratham Innovations help reduce cloud costs?', a: 'Our cloud optimization services help identify waste, right-size resources, and implement cost-saving strategies across AWS, Azure, and Google Cloud.' },
  { q: 'Is Pratham Innovations suitable for small businesses?', a: 'Absolutely. We offer scalable solutions that grow with your business, ensuring you only pay for what you need while maintaining enterprise-grade quality.' }
];

export const integrationTags = [
  'API Orchestration', 'Data system', 'Workflow', 'CRM integration', 'Intelligent routing',
  'Lead scoring', 'Chatbot', 'RPA solution', 'AI assistants', 'Model deployment',
  'Prediction', 'Data synchronization', 'Process opt'
];
